import { combineReducers } from 'redux';
import sample_data from './sample_data';
import location_data from './location_data';
import results_data from './results_data';
import floor_data from './floor_data';
import notification_data from './notification_data';
import wiki_data from './wiki_data';
import announcements_data from './announcements_data';
import dashboard_data from './dashboard_data';

export default combineReducers({
    sample_data,
    location_data,
    results_data,
    floor_data,
    notification_data,
    wiki_data,
    announcements_data,
    dashboard_data,
    // Expose floorsList separately for easier access
    floorsListReducer: (state = [], action) => {
        if (action.type === 'FETCH_BUILDINGS_LIST') {
            const allFloors = [];
            const buildings = action.payload.hasOwnProperty('results') ? action.payload.results : action.payload;
            buildings.forEach(building => {
                if (building.floors) {
                    building.floors.forEach(floor => {
                        allFloors.push({
                            ...floor,
                            building: building
                        });
                    });
                }
            });
            return allFloors;
        }
        return state;
    },
    buildingListReducer: (state = [], action) => {
        if (action.type === 'FETCH_BUILDINGS_LIST') {
            return action.payload.hasOwnProperty('results') ? action.payload.results : action.payload;
        }
        return state;
    }
})